import ReactDOM from 'react-dom/client'
import { setFetched } from 'reduxes/slices/api/actions'
import apiRoutes from 'routes/admin_api_routes.json'
import liteApiRoutes from 'routes/lite_api_routes.json'

import { handleApiError } from '../../util/parse_server_error'

export function sendChat(topicId, chat, replyTimelineId) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_chats.path
    const url = path.replace(':topic_id', topicId)
    return axios()
      .post(url, { chat, reply_timeline_id: replyTimelineId })
      .then(
        (result) => {
          dispatch(setFetched('chats', result.data.records))

          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
            uniqueKey: topicId,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function createNewLiveChat(chat) {
  return function (axios, dispatch) {
    const path = liteApiRoutes.lite_api_v1_lazy_chat_new.path
    return axios()
      .post(path, { chat })
      .then(
        (result) => {
          dispatch(setFetched('chats', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function updateChat(chat, attributes) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_chat.path
    const url = path.replace(':topic_id', chat.topic_id).replace(':id', chat.id)
    return axios()
      .put(url, { chat: attributes })
      .then((result) => {
        dispatch(setFetched('chats', result.data.records))
        return Promise.resolve(result)
      })
  }
}

export function deleteChat(chat) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_chat.path
    const url = path.replace(':topic_id', chat.topic_id).replace(':id', chat.id)
    return axios()
      .delete(url)
      .then(
        (result) => {
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
            uniqueKey: chat.id,
          })
          return Promise.reject(result)
        },
      )
  }
}
